import "./LoyalitySchemeAccordion.css";
import "./LoyalityScheme/OrderHistoryModal.css";
import axios from "axios";
import jwtDecode from "jwt-decode";
import { useEffect, useState } from "react";
import OrderHistoryModal from "./LoyalityScheme/OrderHistoryModal";
import LoyaltyQR from "./LoyalityScheme/LoyaltyQR";
import LoyaltyMemberInfo from "./LoyalityScheme/LoyaltyMemberInfo";
import RewardsModal from "./LoyalityScheme/RewardsModal";
import gift from "./../../../Assets/Image/gift_c.png";
import PointsTab from "./LoyalityScheme/PointsTab";
import HistoryTab from "./LoyalityScheme/HistoryTab";
import OrderHistory from "./LoyalityScheme/OrderHistory";

const LoyalitySchemeAccordion = () => {
  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState(null);
  const [restaurants, setRestaurants] = useState([]);
  const [user, setUser] = useState([]);
  const [redemptionHistory, setRedemptionHistory] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);
  const [selectedRestaurantName, setSelectedRestaurantName] = useState(null);
  const [selectedOrders, setSelectedOrders] = useState([]);

  const [isRestaurantsLoading, setIsRestaurantsLoading] = useState(true);
  const [isOrdersLoading, setIsOrdersLoading] = useState(false);

  const [isRewardsModalOpen, setIsRewardsModalOpen] = useState(false);
  const [selectedRestaurantForRewards, setSelectedRestaurantForRewards] =
    useState(null);
  const [restaurantRewards, setRestaurantRewards] = useState([]);
  const [orderDetails, setOrderDetails] = useState([]);
  const [activeTab, setActiveTab] = useState("points");

  const [pointsSearch, setPointsSearch] = useState("");
  const [historySearch, setHistorySearch] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("gotasteClienttoken");
    if (!token) return;

    try {
      const decoded = jwtDecode(token);
      if (decoded?.UserId) setUserId(decoded.UserId);
      setUserName(decoded.UserName);
    } catch (err) {
      console.error("Invalid token", err);
    }
  }, []);

  useEffect(() => {
    if (!userId) return;

    const fetchData = async () => {
      setIsRestaurantsLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SECRET}/api/LoyaltyScheme/GetCustomerLoyaltyOverview`,
          { params: { CustomerId: userId } },
        );

        const overview = response.data;

        console.log("overview", overview);
        setUser(overview.customerDetails);
        setOrderDetails(overview.orderDetails || []);
        setRestaurants(overview.loyaltyPoints || []);
        setRedemptionHistory(overview.redemptionHistory || []);
        // setAllLoyaltyOrders(overview.LoyaltyOrders || []);
      } catch (error) {
        console.error("Failed to fetch loyalty overview", error);
      } finally {
        setIsRestaurantsLoading(false);
      }
    };

    fetchData();
  }, [userId]);

  const handleRestaurantClick = async (restaurant) => {
    setSelectedRestaurantName(restaurant.restaurantName);

    setSelectedOrders([]);
    setIsOrdersLoading(true);
    setIsModalOpen(true);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SECRET}/api/LoyaltyScheme/GetCustomerLoyaltyOrders`,
        {
          params: {
            CustomerId: userId,
            RestaurantId: restaurant.restaurantId,
          },
        },
      );

      setSelectedOrders(response.data);
    } catch (error) {
      console.error("Failed to load orders", error);
    } finally {
      setIsOrdersLoading(false);
    }
  };

  const handleRewardsClick = async (restaurant) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SECRET}/api/LoyaltyScheme/GetLoyaltySchemeWithReward`,
        {
          params: {
            CustomerId: userId,
            RestaurantId: restaurant.restaurantId,
          },
        },
      );

      setRestaurantRewards(response.data);
      setSelectedRestaurantForRewards(restaurant);
      setIsRewardsModalOpen(true);
    } catch (error) {
      console.error(error);
    } finally {
      // setIsRestaurantsLoading(false);
    }
  };

  return (
    <div className="loyalty-page">
      <div className="loyalty-container">
        <div className="left-column">
          <LoyaltyQR userId={userId} userName={userName}></LoyaltyQR>
          <LoyaltyMemberInfo user={user}></LoyaltyMemberInfo>
        </div>

        <div className="right-column">
          <div className="tabs-container">
            <div className="tab-bar">
              <button
                className={`tab ${activeTab === "points" ? "active" : ""}`}
                onClick={() => setActiveTab("points")}
              >
                Points by Restaurant
              </button>
              <button
                className={`tab ${activeTab === "history" ? "active" : ""}`}
                onClick={() => setActiveTab("history")}
              >
                Redemption History
              </button>
              <button
                className={`tab ${
                  activeTab === "orderhistory" ? "active" : ""
                }`}
                onClick={() => setActiveTab("orderhistory")}
              >
                Order History
              </button>
            </div>
            <div className="tab-content">
              {activeTab === "points" && (
                <PointsTab
                  restaurants={restaurants}
                  isRestaurantsLoading={isRestaurantsLoading}
                  pointsSearch={pointsSearch}
                  setPointsSearch={setPointsSearch}
                  handleRestaurantClick={handleRestaurantClick}
                  handleRewardsClick={handleRewardsClick}
                  gift={gift}
                />
              )}
              {activeTab === "history" && (
                <HistoryTab
                  redemptionHistory={redemptionHistory}
                  historySearch={historySearch}
                  setHistorySearch={setHistorySearch}
                />
              )}
              {activeTab === "orderhistory" && (
                <OrderHistory orderDetails={orderDetails}></OrderHistory>
              )}
            </div>
          </div>
        </div>
      </div>

      <RewardsModal
        open={isRewardsModalOpen}
        onClose={() => setIsRewardsModalOpen(false)}
        restaurant={selectedRestaurantForRewards}
        rewards={restaurantRewards}
      />

      <OrderHistoryModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        restaurantName={selectedRestaurantName}
        orders={selectedOrders}
        loading={isOrdersLoading}
      />
    </div>
  );
};

export default LoyalitySchemeAccordion;
